import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_236: DocMigration = {
  maxSchemaVersion: "0.0.236",
  description: "Move verticalDivisionSpacing to window settings",
  apply(json: any) {
    function moveProp(window: any) {
      const oldProp = window?.exteriorCasing?.verticalDivisionSpacing;
      if (oldProp !== undefined) {
        window.verticalDivisionSpacing = oldProp;
        delete window.exteriorCasing.verticalDivisionSpacing;
      }
    }

    // collect settings
    const windowCasingSettings: string[] = [];
    const windowCatalogSettings: string[] = [];
    const windowSettings: string[] = [];

    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "EXTERIOR_WINDOW_CASING_SETTINGS") {
        windowCasingSettings.push(settingId);
      } else if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        windowCatalogSettings.push(settingId);
      } else if (setting.type === "WINDOW_SETTINGS") {
        windowSettings.push(settingId);
      }
    }

    // move verticalDivisionSpacing from exteriorCasing to window settings
    for (const settingId of windowCasingSettings) {
      const windowCasingSetting = json.settings[settingId];
      if (windowCasingSetting && windowCasingSetting.verticalDivisionSpacing !== undefined) {
        let windowSettingFound = false;
        for (const windowSettingId of windowSettings) {
          const windowSetting = json.settings[windowSettingId];
          if (windowSetting && windowSetting.parentId === windowCasingSetting.parentId) {
            windowSettingFound = true;
            windowSetting.verticalDivisionSpacing = windowCasingSetting.verticalDivisionSpacing;
            delete windowCasingSetting.verticalDivisionSpacing;
          }
        }
        if (!windowSettingFound) {
          // create a new window setting
          const newSettingsId = uid();
          (json.settings[newSettingsId] as any) = {
            ...{
              type: "WINDOW_SETTINGS",
              verticalDivisionSpacing: windowCasingSetting.verticalDivisionSpacing,
            },
            entityType: "SETTINGS",
            id: newSettingsId,
            parentId: windowCasingSetting.parentId,
            sortIndex: 0,
          };

          delete windowCasingSetting.verticalDivisionSpacing;
        }
      }
    }

    for (const settingId of windowCatalogSettings) {
      const windowCatalog = json.settings[settingId];
      for (const windowTypeId in windowCatalog.windowTypes) {
        const windowType = windowCatalog.windowTypes[windowTypeId];
        if (windowType?.exteriorCasing?.verticalDivisionSpacing !== undefined) {
          moveProp(windowType);
        }
        // there may be cases where the vertical divisions setting is suppressed by the window type, but is now active on arched top windows
        if (
          windowType.shape === "RECTANGLE_ARCHED_TOP" &&
          (windowType.verticalDivisions === "TWIN" || windowType.verticalDivisions === "TRIPLE")
        ) {
          windowType.verticalDivisions = "SINGLE";
        }
      }
    }

    // update instances
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];
      if (opening) {
        moveProp(opening);
      }
    }

    for (const openingId in json.gableOpenings) {
      const opening = json.gableOpenings[openingId];
      if (opening) {
        moveProp(opening);
      }
    }

    for (const openingId in json.dormers) {
      const opening = json.dormers[openingId];
      if (opening) {
        moveProp(opening);
      }
    }

    return json;
  },
};

export default migration_0_0_236;
